import React from 'react';

class HomeCameraPro extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_608)">
          <g filter="url(#filter0_d_241_608)">
            <path
              d="M61.4302 25.428C61.4302 31.946 58.5202 37.788 53.9262 41.714H26.0742C21.4842 37.788 18.5742 31.946 18.5742 25.428C18.5742 13.596 28.1662 4 40.0022 4C51.8382 4 61.4302 13.596 61.4302 25.428V25.428Z"
              fill="#F7F4F1"
            />
            <path
              d="M40.002 36.574C46.6294 36.574 52.002 31.2014 52.002 24.574C52.002 17.9466 46.6294 12.574 40.002 12.574C33.3745 12.574 28.002 17.9466 28.002 24.574C28.002 31.2014 33.3745 36.574 40.002 36.574Z"
              fill="url(#paint0_linear_241_608)"
            />
            <path
              d="M66.5141 76L67.8001 72.772C67.8001 60.9181 62.7561 49.6261 53.9281 41.7161H26.0741C17.2461 49.6261 12.2021 60.9201 12.2021 72.772L13.4881 76H66.5141Z"
              fill="#F7F4F1"
            />
            <path
              d="M68.6003 72.7719C68.6003 61.5559 64.1443 50.7979 56.2983 42.8719C56.2983 42.8719 56.2963 42.8679 56.2943 42.8679C56.2883 42.8619 56.2803 42.8539 56.2743 42.8479C56.1503 42.7239 56.0263 42.5999 55.9023 42.4779C55.7263 42.3039 55.5483 42.1319 55.3723 41.9639C55.3003 41.8959 55.2283 41.8279 55.1563 41.7619C55.1443 41.7499 55.1303 41.7379 55.1183 41.7259C57.4283 39.5839 59.2323 37.0059 60.4463 34.1679C60.4483 34.1639 60.4523 34.1579 60.4543 34.1539C61.3923 31.9559 61.9623 29.6499 62.1563 27.2759C62.1563 27.2639 62.1583 27.2539 62.1603 27.2419C62.1743 27.0679 62.1863 26.8919 62.1963 26.7159C62.1963 26.6859 62.2003 26.6579 62.2023 26.6279C62.2103 26.4659 62.2163 26.3059 62.2223 26.1439C62.2223 26.1039 62.2263 26.0639 62.2263 26.0239C62.2323 25.8299 62.2343 25.6359 62.2343 25.4399V25.4299C62.2343 22.4099 61.6363 19.4759 60.4563 16.7059C60.4463 16.6839 60.4343 16.6639 60.4223 16.6439C57.0103 8.7439 49.1423 3.2019 40.0043 3.2019C30.8663 3.2019 23.0003 8.7439 19.5883 16.6439C19.5763 16.6639 19.5643 16.6839 19.5543 16.7059C18.3743 19.4639 17.7763 22.3999 17.7763 25.4299V25.4399C17.7763 25.6359 17.7803 25.8299 17.7843 26.0239C17.7843 26.0639 17.7883 26.1019 17.7883 26.1419C17.7943 26.3039 17.8003 26.4659 17.8083 26.6279C17.8083 26.6559 17.8123 26.6839 17.8143 26.7139C17.8243 26.8899 17.8363 27.0659 17.8503 27.2399C17.8503 27.2519 17.8523 27.2619 17.8543 27.2739C18.0483 29.6459 18.6183 31.9539 19.5563 34.1519C19.5563 34.1559 19.5603 34.1579 19.5603 34.1619C20.7723 37.0019 22.5763 39.5819 24.8863 41.7239L24.8483 41.7599C24.7763 41.8279 24.7043 41.8939 24.6323 41.9639C24.4563 42.1319 24.2803 42.3039 24.1023 42.4779C23.9783 42.5999 23.8543 42.7239 23.7303 42.8479C23.7243 42.8539 23.7163 42.8619 23.7103 42.8679C23.7103 42.8679 23.7083 42.8719 23.7063 42.8719C15.8603 50.7979 11.4043 61.5559 11.4043 72.7719C11.4043 72.8739 11.4243 72.9739 11.4603 73.0679L12.0623 74.5819L12.7443 76.2979C12.8663 76.6019 13.1603 76.8019 13.4883 76.8019H66.5143C66.8423 76.8019 67.1363 76.6019 67.2583 76.2979L67.9403 74.5839L68.5423 73.0699C68.5803 72.9759 68.5983 72.8759 68.5983 72.7739L68.6003 72.7719ZM21.0883 33.6659V17.1999C24.2723 9.9099 31.5523 4.7999 40.0023 4.7999C48.4523 4.7999 55.7323 9.9099 58.9163 17.1999V33.6639C57.7203 36.4099 55.9303 38.8899 53.6283 40.9139H26.3723C24.0723 38.8899 22.2823 36.4099 21.0883 33.6659V33.6659ZM24.6123 44.2299H55.3903C62.7643 51.7999 66.9603 61.9899 67.0003 72.6199L66.6543 73.4879H13.3463L13.0003 72.6199C13.0403 61.9899 17.2363 51.7999 24.6103 44.2299H24.6123Z"
              fill="#83827F"
            />
            <path
              d="M40.002 30.574C43.3157 30.574 46.002 27.8877 46.002 24.574C46.002 21.2603 43.3157 18.574 40.002 18.574C36.6882 18.574 34.002 21.2603 34.002 24.574C34.002 27.8877 36.6882 30.574 40.002 30.574Z"
              fill="white"
            />
            <path
              d="M40.0022 28.002C41.8955 28.002 43.4302 26.4672 43.4302 24.574C43.4302 22.6808 41.8955 21.146 40.0022 21.146C38.109 21.146 36.5742 22.6808 36.5742 24.574C36.5742 26.4672 38.109 28.002 40.0022 28.002Z"
              fill="url(#paint1_linear_241_608)"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_608"
            x="10.0043"
            y="1.8019"
            width="63.1963"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_608"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_608"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_608"
            x1="31.3776"
            y1="14.7206"
            x2="47.6689"
            y2="33.4077"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_608"
            x1="37.5385"
            y1="21.7592"
            x2="42.1924"
            y2="27.0975"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_608">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default HomeCameraPro;
